<template>
  <!-- 日期过滤
       @author: 王汝鹏
       @date: 2019-9-13
   -->
  <div class="setting-item">
    <el-form-item label="日期过滤"> 
      <el-select class="setting-date_filter" v-model="dateFilter" collapse-tags multiple>
        <el-option label="节假日" :value="1"></el-option>
        <el-option label="周日" :value="2"></el-option>
        <el-option label="双休" :value="3"></el-option>
      </el-select>
    </el-form-item>
  </div>
</template>

<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
export default {
  mixins: [ mixValueWatch ],
  computed: {
    /** @name 日期过滤
     *  @description 将 dateFilter 字段映射到当前 dateFilter 计算属性
     *  @return {String}
     *  @author 王汝鹏
     *  @version 2019-09-10
     */
    ...mapComputed({
      dateFilter: { 
        parent: i => i.baseOption,
        attr: "dateFilter",
        getFormat: (value) => { 
          let options = [];
          for (let index in value) { options.push(value[index]); }
          return options;
        }
      }
    })
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/base_setting/SettingDateFilter.vue